module.exports = __webpack_public_path__ + "img/Eiszeit.9f2130f9.jpg";